/* ==========================================================================
   Accordion block — hide when empty
   Verified against Hyper theme DOM — April 2026
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* Hyper's collapsible tab wrapper — one per accordion block */
  const accordionItems = document.querySelectorAll('.product__block--collapsible_tab');

  accordionItems.forEach(function (item) {

    /* Hyper's content panel class — confirmed in DOM */
    const panel = item.querySelector('.accordion-details__content');

    if (!panel) return;

    /* Strip tags and whitespace — catches empty <p> and rich text shells */
    const text = panel.innerHTML
      .replace(/<[^>]*>/g, '')
      .trim();

    if (text === '') {
      item.style.display = 'none';
    }

  });

});


/* ==========================================================================
   TEMPORARY — Product card, collection card + product page image normalisation
   Uses MutationObserver to strip Hyper's inline --aspect-ratio as it's
   injected. DOMContentLoaded fires too early — Hyper sets the style after
   page load. Observer catches it as soon as it appears and removes it.
   Covers: product cards, collection cards, product page main image.
   Remove once all images are properly sized at upload.
   ========================================================================== */

function stripAspectRatio() {
  document.querySelectorAll(
    '.product-card__image--main, .collection-card__image, .product__media-item-container'
  ).forEach(function (el) {
    el.style.removeProperty('--aspect-ratio');
  });
}

/* Run once immediately on script load */
stripAspectRatio();

/* Watch for Hyper re-injecting the inline style after load */
const observer = new MutationObserver(stripAspectRatio);
observer.observe(document.body, {
  subtree: true,
  attributeFilter: ['style'],
  attributes: true
});

/* ==========================================================================
   In-store only template — hide shipping and payment info
   ========================================================================== */

if (document.body.classList.contains('in-store-only')) {
  document.querySelectorAll('.product__tax').forEach(function(el) {
    el.innerHTML = el.innerHTML.replace(/<a[^>]*>Shipping<\/a>\s*calculated at checkout\.?/i, '');
  });

  /* Hide Shop Pay instalments block */
  document.querySelectorAll('.shopify-payment-terms, shop-pay-installments, [id*="shopify-installments"]').forEach(function(el) {
    el.style.display = 'none';
  });
}